import React, { useEffect, useState } from "react";
import { CalendarClock, Zap, Trophy, Newspaper } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { useNotifPick } from "../../lib/useNotifPick";
import { TEAM_INFO } from "../../lib/teamMap";

const TOPIC_ROWS = [
    ["sched", "Game about to start", "15 min before + puck drop", CalendarClock],
    ["goals", "Goals", "Every goal, as it happens", Zap],
    ["final", "End of game", "The final score", Trophy],
    ["news", "News", "Breaking news & signings", Newspaper],
];

// Global popup (all devices): turning a team / league / conference / division ON asks which alerts.
export function NotifTopicsDialog() {
    const notif = useNotifPick();
    const [req, setReq] = useState(null);
    const [picked, setPicked] = useState([]);
    useEffect(() => {
        const on = (e) => { setReq(e.detail); setPicked(notif.sufs(e.detail.lg)); };
        window.addEventListener("notif-topics-pick", on);
        return () => window.removeEventListener("notif-topics-pick", on);
    }, [notif]);
    if (!req) return null;
    const rows = TOPIC_ROWS.filter(([k]) => notif.sufs(req.lg).includes(k));
    const who = req.ids.length === 1 ? (req.lg === "pwhl" ? TEAM_INFO[req.ids[0]]?.name || req.ids[0] : req.ids[0]) : `${req.ids.length} teams`;
    const flip = (k) => setPicked((p) => (p.includes(k) ? p.filter((x) => x !== k) : [...p, k]));
    const done = () => { notif.setMany(req.lg, req.ids, true, picked); setReq(null); };
    return (
        <Dialog open onOpenChange={(o) => { if (!o) setReq(null); }}>
            <DialogContent className="max-w-sm bg-[#0B0D14] border-white/10 text-white" data-testid="notif-topics-dialog">
                <DialogHeader>
                    <DialogTitle className="text-base font-black">Notifications for {who}</DialogTitle>
                    <DialogDescription className="text-xs text-white/50">Pick what you'd like to be told about.</DialogDescription>
                </DialogHeader>
                <div className="space-y-1.5">
                    {rows.map(([k, label, hint, Icon]) => {
                        const on = picked.includes(k);
                        return (
                            <button key={k} type="button" onClick={() => flip(k)} data-testid={`notif-topic-${k}`}
                                className={`w-full flex items-center gap-3 rounded-xl border px-3 py-2.5 text-left transition-colors ${on ? "border-[#9D4CDD]/60 bg-[#9D4CDD]/10" : "border-white/10 bg-white/[0.02] hover:border-white/25"}`}>
                                <Icon className={`h-4 w-4 shrink-0 ${on ? "text-[#C084FC]" : "text-white/40"}`} />
                                <span className="min-w-0 flex-1"><span className="block text-sm font-bold">{label}</span><span className="block text-[11px] text-white/45">{hint}</span></span>
                                <span className={`relative inline-flex items-center w-10 h-5 rounded-full shrink-0 transition-colors ${on ? "bg-[#9D4CDD]" : "bg-white/15"}`}>
                                    <span className={`absolute top-1/2 -translate-y-1/2 h-4 w-4 rounded-full bg-white shadow transition-all ${on ? "left-[calc(100%-1.125rem)]" : "left-0.5"}`} />
                                </span>
                            </button>
                        );
                    })}
                </div>
                <div className="flex gap-2 pt-1">
                    <button type="button" onClick={() => setReq(null)} data-testid="notif-topics-cancel" className="flex-1 rounded-full border border-white/15 py-2 text-xs font-black uppercase tracking-wider text-white/70 hover:text-white">Cancel</button>
                    <button type="button" onClick={done} disabled={!picked.length} data-testid="notif-topics-save" className="flex-1 rounded-full bg-[#9D4CDD] py-2 text-xs font-black uppercase tracking-wider text-white disabled:opacity-40">Turn on</button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
